import React from 'react';
export const CFIconTwitterLogo = {
    alias: 'twitter',
    defaultTitle: 'Twitter',
    source: ({ Path }) => (React.createElement(Path, { d: 'M22.258 6.85c.01.21.01.42.01.64 0 6.51-4.95 14.01-14.01 14.01-2.68 0-5.3-.77-7.55-2.21a9.916 9.916 0 0 0 7.29-2.04 4.917 4.917 0 0 1-4.6-3.42c.74.14 1.5.11 2.22-.08a4.917 4.917 0 0 1-3.95-4.83v-.06c.68.38 1.45.59 2.23.62a4.944 4.944 0 0 1-1.51-6.58c2.5 3.08 6.19 4.95 10.15 5.14-.4-1.71.15-3.5 1.42-4.7a4.94 4.94 0 0 1 6.97.21 9.86 9.86 0 0 0 3.13-1.2 4.952 4.952 0 0 1-2.16 2.72c.98-.12 1.93-.38 2.83-.77-.66.99-1.49 1.85-2.46 2.55h-.01Z' })),
};
